export enum TableNames {
  MY_PA_ORDERS = "my_pa_orders",
  MEDICAL_PA_ORDERS_NEW = "medical_pa_orders_new",
  ALL_PA_ORDERS = "all_pa_orders",
  GENERIC_AUTH_STATUS_ORDERS = "generic_auth_status_table",
  DRAFT_SUBMISSION_CPT_TABLE = "draft_submission_cpt_table",
  CLINICAL_DATA = "clinical-data",
  MY_PA_ORDERS_FROM_ALGOLIA = "my_pa_orders_from_algolia",
  REVIEW_PENDING_ORDERS_FROM_ALGOLIA = "review_pending_orders_from_algolia",
  ALL_OPEN_ORDERS = "all_open_orders",
  QUICK_REVIEW_TABLE = "quick_review_table",
  /** Worked vs newly ingested field diff inside the Quick Review modal */
  QUICK_REVIEW_DIFF_TABLE = "quick_review_diff_table",
}
